import { render, staticRenderFns } from "./communications.vue?vue&type=template&id=1e2b9b1b&scoped=true&lang=pug"
import script from "./communications.vue?vue&type=script&lang=js"
export * from "./communications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2b9b1b",
  null
  
)

/* custom blocks */
import block0 from "./communications.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports